import React, { useState, useEffect } from 'react'
import { login } from '../../actions/login'
import  { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { getUsers } from '../../actions/login';

const initialState = {_id: '', username: '', password: '', firstName: '', secondName: '', userType: '', choices: '', shortlist: '', noOfStudents: 0, progressTime: '', demoTime: ''};
 
/**
  * This page presents the user with a form to fill out to allow them to login to their account.
  * When the login form is submitted it will automatically direct them to the homepage that is associated to their account.
  * If their details are incorrect it will not direct them to a homepage and ask them to fill out the form again.
  * @returns the login form with two textfields
  */

function Login() {

    const [loginDetails, setLoginDetails] = useState(initialState);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getUsers());
    }, [dispatch]);

    let users = []
    const response = useSelector((state) => state.projects.data);
    if (response){
        users = Array.from(response);
    }

    const handleLogin = (e) => {
        e.preventDefault();

        const userData = users.find((user) => user.username === loginDetails.username);

        if (userData) {
            if (userData.password !== loginDetails.password) {
              alert("incorrect password")
            }
            else {
                loginDetails._id = userData._id
                loginDetails.username = userData.username
                loginDetails.password = userData.password
                loginDetails.firstName = userData.firstName
                loginDetails.secondName = userData.secondName
                loginDetails.userType = userData.userType
                loginDetails.choices = userData.choices
                loginDetails.shortlist = userData.shortlist
                loginDetails.noOfStudents = userData.noOfStudents
                loginDetails.progressTime = userData.progressTime
                loginDetails.demoTime = userData.demoTime

                dispatch(login(loginDetails, navigate))
                localStorage.setItem("id", loginDetails._id)
                localStorage.setItem("username", loginDetails.username)
                localStorage.setItem("password", loginDetails.password)
                localStorage.setItem("firstName", loginDetails.firstName)
                localStorage.setItem("secondName", loginDetails.secondName)
                localStorage.setItem("userType", loginDetails.userType)
                localStorage.setItem("choices", loginDetails.choices)
                localStorage.setItem("shortlist", loginDetails.shortlist)
                localStorage.setItem("noOfStudents", loginDetails.noOfStudents)
                localStorage.setItem("progressTime", loginDetails.progressTime)
                localStorage.setItem("demoTime", loginDetails.demoTime)
            }
        } else {
            alert("incorrect username")
        }
    }

    const handleDetails = (e) => {
        setLoginDetails({ ...loginDetails, [e.target.name]: e.target.value });
    }

    return (
       <div className="loginContainer">
           <form className="paper loginForm" onSubmit={handleLogin}>
               <h1 className="formTitles">Login</h1>
               <input type="text" name="username" placeholder='username' onChange={ handleDetails } required></input> <br /> <br />
               <input type="password" name="password" placeholder='password' onChange={ handleDetails } required></input> <br /> <br />
               <button className="loginButton" type="submit" name="submit"><p style={{color: "white"}}>Log In</p></button>
           </form>
       </div>
    ) 
}

export default Login